var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
// Entities
import { Thread } from 'packages/email/entities/Thread';
// Components
import Icon from 'common/UIToolKit/Icon.vue';
import DateField from 'ui/v1/DateField.vue';
import UiTextButton from 'ui/v1/controls/UiTextButton.vue';
import UiPaginationControls from 'ui/v1/controls/UiPaginationControls.vue';
import { PaginationQuery } from 'common/PaginationQuery';
import { Pagination } from 'packages/core/Pagination';
import { Getter, namespace } from 'vuex-class';
import { Job } from 'packages/v3/jobs/Job';
var jobsModule = namespace('jobs');
var talentEmail = namespace('talentCard/talentEmailState');
var ThreadList = /** @class */ (function (_super) {
    __extends(ThreadList, _super);
    function ThreadList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lastThreadId = null;
        _this.paging = new PaginationQuery();
        _this.loading = false;
        return _this;
    }
    Object.defineProperty(ThreadList.prototype, "isThreadsEmpty", {
        get: function () {
            return this.threads && this.threads.length === 0 && !this.loading;
        },
        enumerable: false,
        configurable: true
    });
    ThreadList.prototype.invalidNavigationThreadId = function (threadId) {
        return !threadId || threadId === this.lastThreadId || threadId === parseInt(this.$route.query.threadId, 10);
    };
    ThreadList.prototype.setQuery = function (threadId) {
        if (this.invalidNavigationThreadId(threadId)) {
            return;
        }
        return this.$router.push(__assign(__assign({}, this.$route), { query: { threadId: threadId.toString() } }));
    };
    ThreadList.prototype.setThread = function (thread, threadsUpdated) {
        var _a, _b;
        if (threadsUpdated === void 0) { threadsUpdated = false; }
        this.lastThreadId = threadsUpdated ? null :
            ((_a = this.selectedThread) === null || _a === void 0 ? void 0 : _a.id) || thread.id;
        if (thread.id === ((_b = this.selectedThread) === null || _b === void 0 ? void 0 : _b.id) && thread.id === this.lastThreadId) {
            return;
        }
        this.setSelectedThread(thread);
        this.setQuery(thread.id);
    };
    ThreadList.prototype.updateList = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.lastThreadId = (_a = this.selectedThread) === null || _a === void 0 ? void 0 : _a.id;
                        this.loading = true;
                        if (this.pagination.currentPage) {
                            this.paging.page = this.pagination.currentPage;
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getThreads({
                                talentId: this.talentId,
                                jobId: this.candidateIsolationEnabledOrNil ? this.job.id : null,
                            })];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ThreadList.prototype.onThreadsUpdated = function (threads) {
        this.setThread(threads[0], true);
    };
    var _a, _b, _c;
    __decorate([
        Getter,
        __metadata("design:type", Boolean)
    ], ThreadList.prototype, "candidateIsolationEnabledOrNil", void 0);
    __decorate([
        jobsModule.State,
        __metadata("design:type", typeof (_a = typeof Job !== "undefined" && Job) === "function" ? _a : Object)
    ], ThreadList.prototype, "job", void 0);
    __decorate([
        talentEmail.State,
        __metadata("design:type", Array)
    ], ThreadList.prototype, "threads", void 0);
    __decorate([
        talentEmail.State,
        __metadata("design:type", typeof (_b = typeof Thread !== "undefined" && Thread) === "function" ? _b : Object)
    ], ThreadList.prototype, "selectedThread", void 0);
    __decorate([
        talentEmail.State,
        __metadata("design:type", typeof (_c = typeof Pagination !== "undefined" && Pagination) === "function" ? _c : Object)
    ], ThreadList.prototype, "pagination", void 0);
    __decorate([
        talentEmail.Mutation,
        __metadata("design:type", Function)
    ], ThreadList.prototype, "setSelectedThread", void 0);
    __decorate([
        talentEmail.Action,
        __metadata("design:type", Function)
    ], ThreadList.prototype, "getThreads", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], ThreadList.prototype, "talentId", void 0);
    __decorate([
        Watch('threads'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ThreadList.prototype, "onThreadsUpdated", null);
    ThreadList = __decorate([
        Component({
            components: {
                UiPaginationControls: UiPaginationControls,
                UiTextButton: UiTextButton,
                Icon: Icon,
                DateField: DateField,
            },
        })
    ], ThreadList);
    return ThreadList;
}(Vue));
export default ThreadList;
